import React from "react";

const PAIRS = [
  { cx: 22, cy: 18, size: 28, fill: "#FF2D95", open: "“", close: "”", gap: 28, driftDur: 42, dx:  8, dy: -3, rot:  3 },
  { cx: 78, cy: 14, size: 22, fill: "#00E5FF", open: "«", close: "»", gap: 24, driftDur: 50, dx: -6, dy:  4, rot: -4 },
  { cx: 14, cy: 52, size: 24, fill: "#FFEE00", open: "„", close: "“", gap: 26, driftDur: 45, dx:  9, dy: -2, rot:  5 },
  { cx: 86, cy: 50, size: 20, fill: "#FF7AAC", open: "‘", close: "’", gap: 20, driftDur: 48, dx: -7, dy: -4, rot: -3 },
  { cx: 50, cy: 88, size: 22, fill: "#00E5FF", open: "‹", close: "›", gap: 24, driftDur: 55, dx:  5, dy:  6, rot:  4 },
];

export const RetroBackground = () => (
  <div className="absolute w-full h-full overflow-hidden">
    <svg
      preserveAspectRatio="xMidYMid slice"
      className="w-full h-full"
      viewBox="0 0 100 100"
    >
      <defs>
        <linearGradient id="sunsetBg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#1a0a3a" />
          <stop offset="30%"  stopColor="#5e1e7e" />
          <stop offset="50%"  stopColor="#a02e7e" />
          <stop offset="62%"  stopColor="#ff4d7e" />
          <stop offset="65%"  stopColor="#1a0a3a" />
          <stop offset="100%" stopColor="#050014" />
        </linearGradient>

        <linearGradient id="sunGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#FFEE00" />
          <stop offset="55%"  stopColor="#FF8F47" />
          <stop offset="100%" stopColor="#FF2D95" />
        </linearGradient>

        <mask id="sunMask">
          <rect x="0" y="0" width="100" height="100" fill="white" />
          <rect x="0" y="46"  width="100" height="1.2" fill="black" />
          <rect x="0" y="49"  width="100" height="1.2" fill="black" />
          <rect x="0" y="52"  width="100" height="1.2" fill="black" />
          <rect x="0" y="55"  width="100" height="1.2" fill="black" />
          <rect x="0" y="58"  width="100" height="1.2" fill="black" />
        </mask>

        <filter id="neonGlow" x="-100%" y="-100%" width="300%" height="300%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1.4" result="blurWide" />
          <feGaussianBlur in="SourceGraphic" stdDeviation="0.4" result="blurTight" />
          <feMerge>
            <feMergeNode in="blurWide" />
            <feMergeNode in="blurWide" />
            <feMergeNode in="blurTight" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>

        <style>{`
          @keyframes quoteDrift {
            0%,100% { transform: translate(0, 0) rotate(0deg); }
            25%     { transform: translate(calc(var(--dx) * 0.5), calc(var(--dy) * 0.3)) rotate(calc(var(--rot) * 0.4)); }
            50%     { transform: translate(var(--dx), var(--dy)) rotate(var(--rot)); }
            75%     { transform: translate(calc(var(--dx) * 0.3), calc(var(--dy) * 0.7)) rotate(calc(var(--rot) * -0.3)); }
          }
          @keyframes sunPulse {
            0%,100% { opacity: 0.9; }
            50%     { opacity: 1;   }
          }
          .quote-drift {
            animation: quoteDrift var(--drift-dur) ease-in-out infinite;
            transform-origin: center;
            transform-box: fill-box;
          }
          .quote-glyph {
            font-family: 'Georgia', 'Times New Roman', serif;
            font-weight: 900;
            font-style: italic;
          }
          .sun { animation: sunPulse 6s ease-in-out infinite; }
        `}</style>
      </defs>

      <rect x="0" y="0" width="100" height="100" fill="url(#sunsetBg)" />

      <circle
        className="sun"
        cx="50"
        cy="38"
        r="20"
        fill="url(#sunGrad)"
        mask="url(#sunMask)"
        filter="url(#neonGlow)"
      />

      <g stroke="#FF2D95" strokeWidth="0.18" opacity="0.75">
        <line x1="0" y1="62"   x2="100" y2="62"   />
        <line x1="0" y1="64.5" x2="100" y2="64.5" />
        <line x1="0" y1="67.5" x2="100" y2="67.5" />
        <line x1="0" y1="71"   x2="100" y2="71"   />
        <line x1="0" y1="76"   x2="100" y2="76"   />
        <line x1="0" y1="82"   x2="100" y2="82"   />
        <line x1="0" y1="89"   x2="100" y2="89"   />
        <line x1="0" y1="97"   x2="100" y2="97"   />
        <line x1="50" y1="62" x2="-30" y2="100" />
        <line x1="50" y1="62" x2="-5"  y2="100" />
        <line x1="50" y1="62" x2="15"  y2="100" />
        <line x1="50" y1="62" x2="35"  y2="100" />
        <line x1="50" y1="62" x2="65"  y2="100" />
        <line x1="50" y1="62" x2="85"  y2="100" />
        <line x1="50" y1="62" x2="105" y2="100" />
        <line x1="50" y1="62" x2="130" y2="100" />
      </g>

      {PAIRS.map((p, i) => (
        <g
          key={`p-${i}`}
          className="quote-drift"
          style={{
            "--dx": `${p.dx}px`,
            "--dy": `${p.dy}px`,
            "--rot": `${p.rot}deg`,
            "--drift-dur": `${p.driftDur}s`,
          }}
        >
          <g transform={`translate(${p.cx} ${p.cy})`} filter="url(#neonGlow)">
            <text
              className="quote-glyph"
              fontSize={p.size}
              fill={p.fill}
              x={-p.gap / 2}
              y="0"
              textAnchor="middle"
            >
              {p.open}
            </text>
            <text
              className="quote-glyph"
              fontSize={p.size}
              fill={p.fill}
              x={p.gap / 2}
              y="0"
              textAnchor="middle"
            >
              {p.close}
            </text>
          </g>
        </g>
      ))}
    </svg>
  </div>
);
